(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  /* Theme editor only: clicking a slide block in Customize shows that slide.
     Routed through the slide's dot so hom.js's rotation index and timer stay in sync. */
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target;
    if (!slide || !slide.classList || !slide.classList.contains('slide')) return;
    var hero = slide.closest('.hero');
    if (!hero) return;
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.slide'));
    var n = slides.indexOf(slide);
    if (n < 0) return;
    var dot = hero.querySelectorAll('.dots button')[n];
    if (dot) { dot.click(); return; }
    slides.forEach(function (s, k) { s.classList.toggle('active', k === n); });
  });

  /* Tap the hero to see the next slide; swipe left or right to move either way. Routed through
     the dots so hom.js's slide index and its rotation timer stay in sync. Taps on the buttons, links
     and dots are left alone; a drag that is mostly vertical (a scroll), a text selection, a touch that
     only halts a fling scroll, or a press released outside the hero does nothing. Off in the theme
     editor, where clicks select blocks. */
  var lastScroll = 0;
  window.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });
  function initHeroTap(hero) {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!hero || hero.dataset.tapBound) return;
    hero.dataset.tapBound = '1';
    var start = null;
    function dots() { return hero.querySelectorAll('.dots button'); }
    function step(dir) {
      var ds = dots();
      if (ds.length < 2) return;
      var cur = 0;
      for (var k = 0; k < ds.length; k++) { if (ds[k].classList.contains('on')) { cur = k; break; } }
      ds[(cur + dir + ds.length) % ds.length].click();
    }
    function interactive(el) { return !!(el && el.closest && el.closest('a, button, input, select, textarea, label, .dots')); }
    hero.addEventListener('pointerdown', function (e) {
      start = null;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (interactive(e.target)) return;
      if (Date.now() - lastScroll < 150) return;
      start = { x: e.clientX, y: e.clientY, t: Date.now(), id: e.pointerId };
    });
    hero.addEventListener('pointerup', function (e) {
      if (!start || e.pointerId !== start.id) return;
      var dx = e.clientX - start.x, dy = e.clientY - start.y, dt = Date.now() - start.t;
      start = null;
      if (interactive(e.target)) return;
      var sel = window.getSelection && window.getSelection();
      if (sel && sel.type === 'Range' && String(sel).length) return;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) { step(dx < 0 ? 1 : -1); return; }
      if (Math.abs(dx) < 12 && Math.abs(dy) < 12 && dt < 600) step(1);
    });
    hero.addEventListener('pointercancel', function () { start = null; });
    hero.addEventListener('pointerleave', function (e) { if (start && e.pointerId === start.id) start = null; });
    hero.addEventListener('contextmenu', function () { start = null; });
    /* a mouse drag across the photo would start a native image drag and swallow the pointerup */
    hero.addEventListener('dragstart', function (e) { if (start) e.preventDefault(); });
  }
  Array.prototype.forEach.call(document.querySelectorAll('.hero'), initHeroTap);
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.hero'), initHeroTap);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    /* ---- country → province selects (Shopify.CountryProvinceSelector when present, else a tiny fallback) ---- */
    function fillProvinces(country, province, container) {
      var opt = country.options[country.selectedIndex];
      var list = [];
      try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) { list = []; }
      province.innerHTML = '';
      if (!list.length) { container.style.display = 'none'; return; }
      var def = province.getAttribute('data-default');
      list.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1];
        if (p[0] === def) o.selected = true;
        province.appendChild(o);
      });
      container.style.display = '';
    }
    function setupAddressForms(root) {
      var forms = (root || document).querySelectorAll('[data-address-form]');
      Array.prototype.forEach.call(forms, function (wrap) {
        if (wrap.getAttribute('data-ready')) return;
        var country = wrap.querySelector('[data-country-select]');
        var province = wrap.querySelector('[data-province-select]');
        var container = wrap.querySelector('[data-province-container]');
        if (!country || !province || !container) return;
        wrap.setAttribute('data-ready', '1');
        if (window.Shopify && window.Shopify.CountryProvinceSelector && country.id && province.id && container.id) {
          new window.Shopify.CountryProvinceSelector(country.id, province.id, { hideElement: container.id });
          return;
        }
        var def = country.getAttribute('data-default');
        if (def) Array.prototype.forEach.call(country.options, function (o) { if (o.value === def) o.selected = true; });
        country.addEventListener('change', function () { fillProvinces(country, province, container); });
        fillProvinces(country, province, container);
      });
    }
    /* an edit form re-rendered open (validation errors) must report its toggle as expanded */
    function syncToggles(root) {
      Array.prototype.forEach.call((root || document).querySelectorAll('[data-edit-address]'), function (btn) {
        var d = document.getElementById(btn.getAttribute('data-edit-address'));
        if (d) btn.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      });
    }
    /* "Edit" links from the account dashboard land on #address-<id>: open that card's edit form */
    function openFromHash() {
      var m = /^#address-(\d+)$/.exec(window.location.hash || '');
      var d = m && document.getElementById('edit-address-' + m[1]);
      if (d) d.open = true;
    }
    function init() { setupAddressForms(document); openFromHash(); syncToggles(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) { setupAddressForms(e.target); syncToggles(e.target); });

    /* ---- edit / cancel toggles and delete confirmation ---- */
    document.addEventListener('click', function (e) {
      var edit = e.target.closest && e.target.closest('[data-edit-address]');
      if (edit) {
        var d = document.getElementById(edit.getAttribute('data-edit-address'));
        if (d) { e.preventDefault(); d.open = !d.open; edit.setAttribute('aria-expanded', d.open ? 'true' : 'false'); if (d.open) { var i = d.querySelector('input'); if (i) i.focus(); } }
        return;
      }
      var cancel = e.target.closest && e.target.closest('[data-cancel-edit]');
      if (cancel) {
        var dd = cancel.closest('[data-edit-details]');
        if (dd) { dd.open = false; var link = document.querySelector('[data-edit-address="' + dd.id + '"]'); if (link) { link.setAttribute('aria-expanded', 'false'); link.focus(); } }
      }
    });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('[data-delete-address]');
      if (f && f.getAttribute('data-confirm') && !window.confirm(f.getAttribute('data-confirm'))) e.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Collection page (PLP) — instant client-side filtering, sorting and "Load more".
     Every product is already in the DOM; this only toggles visibility and DOM order, so the
     delegated hooks in hom.js (wishlist, quick add) keep working on the very same elements.
     Nothing here animates, so prefers-reduced-motion needs no special case. */
  (function () {
    var GROUPS = ['brands', 'types', 'sizes', 'prices'];

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    function init(root) {
      if (!root || root.getAttribute('data-plp-ready') === 'true') return;
      var grid = root.querySelector('[data-plp-grid]');
      if (!grid) return;
      root.setAttribute('data-plp-ready', 'true');

      var step = parseInt(root.getAttribute('data-plp-step'), 10) || 12;
      var banner = grid.querySelector('[data-plp-banner]');
      var emptyEl = grid.querySelector('[data-plp-empty]');
      var chipsEl = root.querySelector('[data-plp-chips]');
      var sortEl = root.querySelector('[data-plp-sort]');
      var countEl = root.querySelector('[data-plp-count]');
      var shownEl = root.querySelector('[data-plp-shown]');
      var moreEl = root.querySelector('[data-plp-more]');
      var asideEl = root.querySelector('[data-plp-filters]');
      var toggleEl = root.querySelector('[data-plp-toggle]');
      var inputs = toArray(root.querySelectorAll('input[data-group]'));

      /* Merchant wording, printed by Liquid onto the root so the live counters keep using it. */
      var wordOne = root.getAttribute('data-plp-word-one') || 'piece';
      var wordMany = root.getAttribute('data-plp-word-many') || 'pieces';
      var showingTpl = root.getAttribute('data-plp-showing') || 'Showing [shown] of [total]';
      var clearLabel = root.getAttribute('data-plp-clear') || 'Clear all';

      function showingText(visible, total) {
        return showingTpl.split('[shown]').join(visible).split('[total]').join(total);
      }

      var items = toArray(grid.querySelectorAll('[data-plp-card]')).map(function (el) {
        return {
          el: el,
          vendor: el.getAttribute('data-vendor') || '',
          type: el.getAttribute('data-type') || '',
          sizes: el.getAttribute('data-sizes') || '',
          price: parseInt(el.getAttribute('data-price'), 10) || 0,
          title: el.getAttribute('data-title') || '',
          order: parseInt(el.getAttribute('data-order'), 10) || 0,
          on: true,
          shown: false
        };
      });

      var buckets = {};
      inputs.forEach(function (input) {
        if (input.getAttribute('data-group') !== 'prices') return;
        buckets[input.value] = [
          parseInt(input.getAttribute('data-min'), 10) || 0,
          parseInt(input.getAttribute('data-max'), 10) || 0
        ];
      });

      var state = { brands: [], types: [], sizes: [], prices: [], sort: 'curated', shown: step };
      /* items[] is in DOM order, which is the curated order (data-order = the Liquid loop index),
         so the DOM already matches the default sort and needs no reshuffle on first paint. */
      var ordered = items.slice();
      var appliedSort = 'curated';

      function inputFor(group, value) {
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].getAttribute('data-group') === group && inputs[i].value === value) return inputs[i];
        }
        return null;
      }

      function labelOf(group, value) {
        var input = inputFor(group, value);
        var label = input && input.getAttribute('data-label');
        return label || value;
      }

      function matches(item) {
        var i;
        if (state.brands.length && state.brands.indexOf(item.vendor) < 0) return false;
        if (state.types.length && state.types.indexOf(item.type) < 0) return false;
        if (state.sizes.length) {
          var sizeHit = false;
          for (i = 0; i < state.sizes.length; i++) {
            if (item.sizes.indexOf('|' + state.sizes[i] + '|') > -1) sizeHit = true;
          }
          if (!sizeHit) return false;
        }
        if (state.prices.length) {
          var priceHit = false;
          for (i = 0; i < state.prices.length; i++) {
            var range = buckets[state.prices[i]];
            if (!range) continue;
            if (item.price >= range[0] && (range[1] <= 0 || item.price < range[1])) priceHit = true;
          }
          if (!priceHit) return false;
        }
        return true;
      }

      function compare(a, b) {
        if (state.sort === 'price-asc') return (a.price - b.price) || (a.order - b.order);
        if (state.sort === 'price-desc') return (b.price - a.price) || (a.order - b.order);
        if (state.sort === 'designer') return a.vendor.localeCompare(b.vendor) || a.title.localeCompare(b.title) || (a.order - b.order);
        return a.order - b.order;
      }

      function renderChips() {
        if (!chipsEl) return;
        toArray(chipsEl.querySelectorAll('[data-plp-chip]')).forEach(function (chip) {
          chip.parentNode.removeChild(chip);
        });
        var total = 0;
        GROUPS.forEach(function (group) {
          state[group].forEach(function (value) {
            var label = labelOf(group, value);
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'chip';
            button.setAttribute('data-plp-chip', group);
            button.setAttribute('data-plp-value', value);
            button.setAttribute('aria-label', 'Remove ' + label + ' filter');
            button.textContent = label + ' ✕';
            chipsEl.appendChild(button);
            total += 1;
          });
        });
        if (!total) return;
        var clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'chip';
        clear.style.borderStyle = 'dashed';
        clear.setAttribute('data-plp-chip', 'clear');
        clear.textContent = clearLabel;
        chipsEl.appendChild(clear);
      }

      /* Writing an inline style that is already set would still dirty the node, so compare first.
         Reading el.style.display is a CSSOM read, not a layout read — it forces no reflow. */
      function setDisplay(el, value) {
        if (el.style.display !== value) el.style.display = value;
      }

      /* Only the sort changes the DOM order, so the reshuffle runs on a sort change and nowhere
         else. Filtering and "Load more" then cost display toggles plus one move of the banner —
         not 168 node moves per click. Hidden cards stay where they are: they have no box. */
      function applyOrder() {
        ordered = items.slice().sort(compare);
        var frag = document.createDocumentFragment();
        ordered.forEach(function (item) {
          frag.appendChild(item.el);
        });
        if (emptyEl) grid.insertBefore(frag, emptyEl);
        else grid.appendChild(frag);
      }

      function render() {
        if (appliedSort !== state.sort) {
          applyOrder();
          appliedSort = state.sort;
        }

        var list = [];
        ordered.forEach(function (item) {
          item.on = matches(item);
          item.shown = false;
          if (item.on) list.push(item);
        });

        /* Decide every card's final display first, then write once — a "Load more" click then
           touches the 12 cards it reveals instead of restyling all 168 twice. */
        var visible = Math.min(state.shown, list.length);
        for (var i = 0; i < visible; i++) list[i].shown = true;
        ordered.forEach(function (item) {
          setDisplay(item.el, item.shown ? 'contents' : 'none');
        });

        if (banner) {
          if (visible > 6) {
            if (banner.parentNode !== grid || banner.nextElementSibling !== list[6].el) {
              grid.insertBefore(banner, list[6].el);
            }
            setDisplay(banner, '');
          } else {
            setDisplay(banner, 'none');
          }
        }

        if (emptyEl) setDisplay(emptyEl, list.length ? 'none' : '');
        if (countEl) countEl.textContent = list.length + ' ' + (list.length === 1 ? wordOne : wordMany);
        if (shownEl) shownEl.textContent = showingText(visible, list.length);
        if (moreEl) setDisplay(moreEl, state.shown >= list.length ? 'none' : '');
        renderChips();
      }

      function removeFilter(group, value) {
        if (GROUPS.indexOf(group) < 0) return;
        var at = state[group].indexOf(value);
        if (at > -1) state[group].splice(at, 1);
        var input = inputFor(group, value);
        if (input) input.checked = false;
        render();
      }

      function clearAll() {
        GROUPS.forEach(function (group) {
          state[group].length = 0;
        });
        inputs.forEach(function (input) {
          input.checked = false;
        });
        state.shown = step;
        render();
      }

      function toggleFilters() {
        if (!asideEl || !toggleEl) return;
        /* data-plp-open, never data-open: hom.js treats a click inside any [data-open] element as
           "open that overlay" and cancels it — that made the filters untouchable on phones once the panel was up. */
        var open = asideEl.getAttribute('data-plp-open') === 'true';
        asideEl.style.display = open ? '' : 'block';
        asideEl.setAttribute('data-plp-open', open ? 'false' : 'true');
        toggleEl.setAttribute('aria-expanded', open ? 'false' : 'true');
        toggleEl.textContent = (toggleEl.getAttribute('data-label') || 'Filters') + (open ? ' +' : ' −');
      }

      root.addEventListener('change', function (event) {
        var target = event.target;
        if (!target) return;
        if (target === sortEl) {
          state.sort = sortEl.value;
          state.shown = step;
          render();
          writeAddress();
          return;
        }
        if (!target.getAttribute) return;
        var group = target.getAttribute('data-group');
        if (!group || GROUPS.indexOf(group) < 0) return;
        var at = state[group].indexOf(target.value);
        if (target.checked && at < 0) state[group].push(target.value);
        if (!target.checked && at > -1) state[group].splice(at, 1);
        state.shown = step;
        render();
        writeAddress();
      });

      root.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var chip = target.closest('[data-plp-chip]');
        if (chip) {
          event.preventDefault();
          var group = chip.getAttribute('data-plp-chip');
          if (group === 'clear') clearAll();
          else removeFilter(group, chip.getAttribute('data-plp-value'));
          writeAddress();
          return;
        }
        if (target.closest('[data-plp-more]')) {
          event.preventDefault();
          state.shown += step;
          render();
          return;
        }
        if (target.closest('[data-plp-toggle]')) {
          event.preventDefault();
          toggleFilters();
        }
      });

      /* Filters can arrive in the address, which is how the menu opens a category pre-filtered:
         /collections/womens?type=Dresses · type=Tops,Dresses · designer=Rigash · size=M · sort=price-asc
         Values are matched to the sidebar's own values, ignoring case. A parameter is tried whole first
         (a type such as "Hair, Small Goods" keeps its comma), then as a comma list. A value nothing on the
         page carries — a renamed type, or a slice with no pieces yet — stays on as a filter, so the page
         shows the empty state with a chip naming it instead of quietly showing everything. */
      var PARAM = { brands: 'designer', types: 'type', sizes: 'size', prices: 'price' };
      function readAddress() {
        var query = window.location.search.replace(/^\?/, '');
        if (!query) return;
        query.split('&').forEach(function (pair) {
          var eq = pair.indexOf('=');
          if (eq < 0) return;
          var key, value;
          try { key = decodeURIComponent(pair.slice(0, eq).replace(/\+/g, ' ')); value = decodeURIComponent(pair.slice(eq + 1).replace(/\+/g, ' ')); } catch (e) { return; }
          if (key === 'sort' && sortEl) {
            for (var o = 0; o < sortEl.options.length; o++) if (sortEl.options[o].value === value) sortEl.value = value;
            return;
          }
          var group = null;
          GROUPS.forEach(function (g) { if (PARAM[g] === key) group = g; });
          if (!group) return;
          var parts = valueFor(group, value) !== null ? [value] : value.split(',');
          parts.forEach(function (raw) {
            var want = raw.trim();
            if (!want) return;
            var found = valueFor(group, want);
            if (found === null) {
              if (group !== 'prices' && state[group].indexOf(want) < 0) state[group].push(want);
              return;
            }
            var input = inputFor(group, found);
            if (input) input.checked = true;
            if (state[group].indexOf(found) < 0) state[group].push(found);
          });
        });
      }
      /* The sidebar's own spelling of a value, matched ignoring case — null when the page has no such filter. */
      function valueFor(group, raw) {
        var want = raw.trim().toLowerCase();
        if (!want) return null;
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].getAttribute('data-group') === group && inputs[i].value.toLowerCase() === want) return inputs[i].value;
        }
        return null;
      }
      function writeAddress() {
        if (!window.history || !window.history.replaceState || !window.URL) return;
        try {
          var url = new URL(window.location.href);
          GROUPS.forEach(function (g) {
            url.searchParams.delete(PARAM[g]);
            if (!state[g].length) return;
            var comma = false;
            state[g].forEach(function (v) { if (v.indexOf(',') > -1) comma = true; });
            if (comma) state[g].forEach(function (v) { url.searchParams.append(PARAM[g], v); });
            else url.searchParams.set(PARAM[g], state[g].join(','));
          });
          if (state.sort && state.sort !== 'curated') url.searchParams.set('sort', state.sort);
          else url.searchParams.delete('sort');
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) { /* the address is a convenience, never a requirement */ }
      }

      /* Browsers restore checkbox / select state on reload — start from what the DOM says, then the address. */
      inputs.forEach(function (input) {
        if (!input.checked) return;
        var group = input.getAttribute('data-group');
        if (GROUPS.indexOf(group) > -1 && state[group].indexOf(input.value) < 0) state[group].push(input.value);
      });
      readAddress();
      if (sortEl && sortEl.value) state.sort = sortEl.value;
      render();
    }

    function boot(scope) {
      toArray((scope || document).querySelectorAll('[data-plp]')).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot(document);
      });
    } else {
      boot(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    function openRecover() {
      var d = document.querySelector('[data-recover]');
      if (!d || window.location.hash !== '#recover') return;
      /* after a successful reset request the confirmation line keeps focus */
      if (document.querySelector('[data-recover-success]')) return;
      d.open = true;
      var i = d.querySelector('input');
      if (i) i.focus();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openRecover); else openRecover();
    window.addEventListener('hashchange', openRecover);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* Keep aria-pressed in step with the .on class that assets/hom.js toggles on option buttons
     (hom.js's listener sits on the option group, so it has already run when this one fires). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-variant-picker] [data-option-index] [data-value]');
    if (!b) return;
    var g = b.closest('[data-option-index]');
    g.querySelectorAll('[data-value]').forEach(function (x) {
      x.setAttribute('aria-pressed', x.classList.contains('on') ? 'true' : 'false');
    });
  });

  /* ---- product photo lightbox: click a gallery image to enlarge and browse ---- */
  (function () {
    var lb = null, items = [], idx = 0, lastFocus = null, startX = null;
    function collect(sec) { return Array.prototype.slice.call(sec.querySelectorAll('.pdp-gallery [data-lb-src]:not([hidden])')); }
    function show(n) {
      if (!items.length) return;
      idx = (n + items.length) % items.length;
      var img = lb.querySelector('[data-lb-img]');
      var src = items[idx].getAttribute('data-lb-src');
      var inner = items[idx].querySelector('img');
      img.src = src; img.alt = inner ? (inner.alt || '') : '';
      var c = lb.querySelector('[data-lb-count]'); if (c) c.textContent = (idx + 1) + ' / ' + items.length;
      [idx + 1, idx - 1].forEach(function (k) { var it = items[(k + items.length) % items.length]; if (it) { var p = new Image(); p.src = it.getAttribute('data-lb-src'); } });
    }
    function openFrom(el) {
      var sec = el.closest('.pdp-page'); var box = sec && sec.querySelector('[data-lightbox]');
      if (!box) return;
      lb = box; items = collect(sec); lastFocus = document.activeElement;
      lb.hidden = false; document.body.classList.add('lb-open');
      show(Math.max(0, items.indexOf(el)));
      var c = lb.querySelector('[data-lb-close]'); if (c) c.focus();
    }
    function closeLb() {
      if (!lb) return;
      lb.hidden = true; document.body.classList.remove('lb-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lb = null;
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.pdp-gallery [data-lb-src]') : null;
      if (t) { e.preventDefault(); openFrom(t); return; }
      if (!lb) return;
      if (e.target.closest('[data-lb-close]')) { closeLb(); return; }
      if (e.target.closest('[data-lb-prev]')) { show(idx - 1); return; }
      if (e.target.closest('[data-lb-next]')) { show(idx + 1); return; }
      if (e.target === lb || e.target.classList.contains('lb-stage')) closeLb();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('.pdp-gallery [data-lb-src]')) { e.preventDefault(); openFrom(e.target.closest('[data-lb-src]')); }
        return;
      }
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
    });
    document.addEventListener('touchstart', function (e) { if (lb) startX = e.touches[0].clientX; }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!lb || startX === null) return;
      var dx = e.changedTouches[0].clientX - startX; startX = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(el) {
      if (!el || el.dataset.recsLoaded || !el.dataset.url) return;
      el.dataset.recsLoaded = '1';
      fetch(el.dataset.url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-product-recommendations]');
          if (!fresh || !fresh.innerHTML.trim()) return;
          el.innerHTML = fresh.innerHTML;
          el.querySelectorAll('.reveal').forEach(function (n) { n.classList.add('in'); });
        })
        .catch(function () { /* leave the section empty */ });
    }
    function run(root) {
      (root || document).querySelectorAll('[data-product-recommendations]').forEach(load);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
    else run();
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { run(e.target); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["your-house"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'hom-wishlist';

    function savedHandles() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function money(cents) {
      if (window.HOM && window.HOM.money) return window.HOM.money(cents);
      return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
    }
    function rootPath() {
      var r = (window.HOM && window.HOM.routes && window.HOM.routes.root) || '/';
      return r.replace(/\/+$/, '');
    }
    function sized(url, w) {
      if (!url) return '';
      return url.replace(/\.(jpe?g|png|webp|gif)(\?.*)?$/i, function (m, ext, q) {
        return '_' + w + 'x.' + ext + (q || '');
      });
    }

    function card(tpl, rail, p) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var d = rail.dataset;
      var houseTag = (d.houseTag || '').toLowerCase();
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      var inHouse = houseTag && tags.indexOf(houseTag) !== -1;

      node.setAttribute('href', p.url || (rootPath() + '/products/' + p.handle));

      var slot = node.querySelector('[data-slot-image]');
      if (p.featured_image) {
        var img = document.createElement('img');
        img.className = 'fill';
        img.loading = 'lazy';
        img.alt = p.title || '';
        img.src = sized(p.featured_image, 600);
        slot.appendChild(img);
      } else {
        var cap = document.createElement('span');
        cap.className = 'cap';
        cap.textContent = p.title || '';
        slot.appendChild(cap);
      }

      var frame = node.querySelector('.frame');
      if (inHouse) {
        var ribbon = document.createElement('span');
        ribbon.className = 'ribbon-house';
        ribbon.textContent = d.houseLabel || '';
        frame.insertBefore(ribbon, frame.firstChild);
      } else if (!p.available) {
        var out = document.createElement('span');
        out.className = 'quick';
        out.setAttribute('aria-hidden', 'true');
        out.textContent = d.soldout || '';
        frame.appendChild(out);
      } else if (p.variants && p.variants.length === 1) {
        var add = document.createElement('button');
        add.className = 'quick';
        add.type = 'button';
        add.setAttribute('data-add', '');
        add.setAttribute('data-variant-id', p.variants[0].id);
        add.textContent = d.quick || '';
        frame.appendChild(add);
      } else {
        var choose = document.createElement('span');
        choose.className = 'quick';
        choose.setAttribute('aria-hidden', 'true');
        choose.textContent = d.options || '';
        frame.appendChild(choose);
      }

      var heart = node.querySelector('[data-wish]');
      if (heart) { heart.setAttribute('data-wish', p.handle); heart.style.color = 'var(--clay)'; }

      node.querySelector('[data-slot-vendor]').textContent = p.vendor || '';
      node.querySelector('[data-slot-title]').textContent = p.title || '';

      var priceEl = node.querySelector('[data-slot-price]');
      var base = (typeof p.price_min === 'number') ? p.price_min : p.price;
      var varies = p.price_varies || (p.price_min !== p.price_max);
      priceEl.textContent = (varies && d.from ? d.from + ' ' : '') + money(base);
      var cmp = (typeof p.compare_at_price_min === 'number') ? p.compare_at_price_min : p.compare_at_price;
      if (cmp && cmp > base) {
        var s = document.createElement('s');
        s.className = 'muted';
        s.style.marginLeft = '8px';
        s.textContent = money(cmp);
        priceEl.appendChild(s);
      }
      return node;
    }

    function fill(rail) {
      if (!rail || rail.getAttribute('data-ready')) return;
      rail.setAttribute('data-ready', '1');
      var wrap = rail.parentNode;
      var tpl = wrap.querySelector('[data-wishlist-card]');
      var empty = wrap.querySelector('[data-wishlist-empty]');
      var browse = wrap.querySelector('[data-wishlist-browse]');
      if (!tpl) return;

      var limit = parseInt(rail.getAttribute('data-limit'), 10) || 12;
      var handles = savedHandles().filter(function (h) { return typeof h === 'string' && h; }).slice(0, limit);
      if (!handles.length) return;

      Promise.all(handles.map(function (h) {
        return fetch(rootPath() + '/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (list) {
        var any = false;
        list.forEach(function (p) {
          if (!p || !p.handle) return;
          try { rail.appendChild(card(tpl, rail, p)); any = true; } catch (e) { /* skip malformed */ }
        });
        if (!any) return;
        rail.hidden = false;
        if (wrap.hasAttribute('data-wishlist-wrap')) wrap.hidden = false;
        if (empty) empty.hidden = true;
        if (browse) browse.hidden = true;
      });
    }

    /* ---- "In your bag": re-render the module whenever the header's bag count changes ---- */
    var bagTimer = null;
    function refreshBag() {
      var mod = document.querySelector('.house-page [data-bag-module]');
      var sec = mod && mod.closest('.house-page');
      var id = sec && sec.getAttribute('data-section-id');
      if (!id) return;
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-bag-module]');
          if (!fresh) return;
          mod.innerHTML = fresh.innerHTML;
          mod.hidden = fresh.hasAttribute('hidden');
        })
        .catch(function () { /* keep what is shown */ });
    }
    function watchBag() {
      if (!window.MutationObserver || !document.querySelector('.house-page [data-bag-module]')) return;
      var counts = document.querySelectorAll('.bag-count');
      Array.prototype.forEach.call(counts, function (c) {
        if (c.getAttribute('data-bag-watched')) return;
        c.setAttribute('data-bag-watched', '1');
        new MutationObserver(function () { clearTimeout(bagTimer); bagTimer = setTimeout(refreshBag, 120); })
          .observe(c, { childList: true, characterData: true, subtree: true });
      });
    }
    /* coming back with the browser's Back button can show a remembered page — check the bag again */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshBag(); });

    function init(root) {
      var rails = (root || document).querySelectorAll('.house-page [data-wishlist-rail]');
      Array.prototype.forEach.call(rails, fill);
      watchBag();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
